<div
  class="main-page"
  *ngIf="model === 'faq'"
  [class.static-page]="isStaticPage"
>
  <div class="container faq-page">
    <div class="default-expansion-container" *ngIf="FAQData">
      <p class="title" *ngIf="model != 'faq'">
        {{ FAQData.title || 'Frequently Asked Questions' }}
      </p>
      <div class="page-data">
        <mat-accordion
          *ngIf="
            FAQData.faq_items_detail && FAQData.faq_items_detail.length > 0
          "
        >
          <mat-expansion-panel
            class="mat-elevation-z0"
            *ngFor="let item of FAQData.faq_items_detail"
          >
            <mat-expansion-panel-header>
              <mat-panel-title class="qa-title">
                {{ item.title }}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="context">
              <hr class="custom-hr w-full" />
              <div class="divider"></div>
              <p>{{ item.answer }}</p>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </div>
  </div>
</div>
<section
  *ngIf="model !== 'faq' && FAQData?.faq_items_detail?.length"
  class="faq"
>
  <h2 class="font-regular">Frequently Asked Questions</h2>
  <div class="faq-container" role="group" aria-labelledby="AccID">
    <div class="faq-col">
      <ng-container *ngFor="let item of col1; let i = index">
        <details
          [attr.open]="expandedFaqIndex === i"
          class="faq-item"
          [class.expanded]="expandedFaqIndex === i"
          [class.faq-expanded]="i === expandedFaqIndex"
          (click)="toggleFaq($event, i)"
        >
          <summary>
            <span>{{ item.title }}</span>
            <img
              src="{{
                i === expandedFaqIndex
                  ? kingAseets.ChevronUpBlue
                  : kingAseets.ChevronDownGrey
              }}"
              alt="{{
                item.isExpanded ? 'faq expanded icon' : 'faq collapsed icon'
              }}"
            />
          </summary>
          <div
            class="body-wrapper"
            [@expandCollapse]="
              i === expandedFaqIndex ? 'expanded' : 'collapsed'
            "
          >
            <hr />
            <p>{{ item.answer }}</p>
          </div>
        </details>
      </ng-container>
    </div>
    <div class="faq-col">
      <ng-container *ngFor="let item of col2; let i = index">
        <details
          class="faq-item"
          [class.expanded]="i + col1.length === expandedFaqIndex"
          [class.faq-expanded]="i + col1.length === expandedFaqIndex"
          [attr.open]="expandedFaqIndex === i + col1.length"
          (click)="toggleFaq($event, i + col1.length)"
        >
          <summary>
            <span>{{ item.title }}</span>
            <img
              src="{{
                i === expandedFaqIndex
                  ? kingAseets.ChevronUpBlue
                  : kingAseets.ChevronDownGrey
              }}"
              alt="{{
                item.isExpanded ? 'faq expanded icon' : 'faq collapsed icon'
              }}"
            />
          </summary>
          <div
            [@expandCollapse]="
              i + col1.length === expandedFaqIndex ? 'expanded' : 'collapsed'
            "
          >
            <hr />
            <p>{{ item.answer }}</p>
          </div>
        </details>
      </ng-container>
    </div>
  </div>
</section>
